
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import router from "@/router";
import { useCurrentTime } from "../pages/useCurrentTime";

export default {
  setup() {
    const store = useStore();
    const toast = useToast();
    const dt = ref("");
    const DateString = () => {
      //  const today = new Date();
      //const date = today.getFullYear()+'-'+today.getMonth()+'-'+(today.getDate()-1);
      const today = new Date();
      today.setDate(today.getDate() - 1); //subtractDays(today, 1);

      const yesterday = today;
      //     console.log("######### yesterday: " + yesterday);
      dt.value =  "Thống kê ngày " + yesterday.getDate() + "/"+(yesterday.getMonth()+1) + "/" + yesterday.getFullYear();
    }
    DateString();

    const homeMenu = computed(() => {
      // const menu = ref([
      //   // {
      //   //   label:'Trang chủ',
      //   //   icon:'pi pi-fw pi-home',
      //   //   to: '/'
      //   // },
      //   // {
      //   //   label:'Thống kê bệnh nhân',
      //   //   icon:'pi pi-fw pi-users',
      //   //   to: '/thongkebenhnhan'
      //   // },
      //   // {
      //   //   label:'Thống kê doanh thu',
      //   //   icon:'pi pi-fw pi-dollar',
      //   //   to: '/thongkedoanhthu'
      //   // },
      //   // {
      //   //   label:'Thống kê trực tuyến',
      //   //   icon:'pi pi-fw pi-sync',
      //   //   to: '/thongtintructuyen'
      //   // },
      // ]);
      const menu = ref([
        // {
        //   label:'Trang chủ',
        //   icon:'pi pi-fw pi-home',
        //   to: '/'
        // },
        {
          label: dt.value,
          icon:'pi pi-fw pi-table',
          to: '/thongKeDieuTri'
        },
        {
          label:'Thống kê trực tuyến',
          icon:'pi pi-fw pi-sync',
          to: '/thongKeDieuTriTrucTuyen'
        },
        {
          label:'Thống kê theo thời gian',
          icon:'pi pi-fw pi-calendar-times',
          to: '/thongKeDieuTriTrongThoiGian'
        },
      ]);
      return menu.value;
    })
    const { currentTime } = useCurrentTime();
    console.log(currentTime.value);

    return {
      homeMenu,
      currentTime,
    }
  }
}
